import { createOrderCreationSlice } from 'common/stores/redux/OrderCreation';

const contractorOrderCreationSlice = createOrderCreationSlice(
    'contractorOrderCreation'
);

export const {
    initialize,
    setOrder,
    updateOrder,
    resetPages,
    initializeRoute,
    updateKeyValuePair,
    addNote,
    initFinancialInformation,
    updatePayment,
    updateBilling,
    updateNote,
    updateSpecialInstructions,
    addContact,
    removeContact,
    addComment,
    updateComment,
    addFolderAttachment,
    removeFolderAttachment,
    updateFulfillmentLogistics,
    setFinanceEdit,
    setDefaultTradeAndPriority,
    updateFulfillmentDetails,
    updateTradeType,
    updateProperty,
    reset,
} = contractorOrderCreationSlice.actions;

/**
 * Updates the client for an order, fetching and applying client-specific settings
 * @type {import('@reduxjs/toolkit').AsyncThunk<any, number, {}>}
 */
export const updateClient = contractorOrderCreationSlice.thunks.updateClient;

export default contractorOrderCreationSlice.reducer;
